import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  label: {
    background: '#272727',
    color: '#919191',
    composes: [
      'is-italic',
      'fs12',
      'px12',
      'py3',
      'is-absolute',
      'text-center',
    ],
    top: 0,
  },
  section: {
    '& + $section': { marginTop: 32 },
    composes: ['px15'],
  },
  title: {
    '&::before': {
      borderBottom: '1px solid #393939',
      content: '""',
      display: 'block',
      height: 1,
      position: 'absolute',
      top: 8,
      width: '100%',
    },
    color: '#FFFFFF',
    composes: ['is-block', 'mb12', 'is-relative', 'text-center'],
    height: 20,
  },
});

const SectionComponent = React.memo(({ children, title }) => {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.title}>
        <i className={classes.label}>{title}</i>
      </div>
      {children}
    </div>
  );
});

SectionComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.elementType, PropTypes.node])
    .isRequired,
  title: PropTypes.string.isRequired,
};

SectionComponent.displayName = 'SectionComponent';

export default SectionComponent;
